import { initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAlalLs6fJBTMCgKt0B7b1fSR5tQo2Bx-M",
  authDomain: "og-photo-app.firebaseapp.com",
  projectId: "og-photo-app",
  storageBucket: "og-photo-app.firebasestorage.app",
  messagingSenderId: "275152595711",
  appId: "1:275152595711:web:dee1c748ec04797623faca",
  measurementId: "G-2G1DC7MG1M",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const storage = getStorage(app);

export const auth = getAuth(app);

export default app;
